<section class="raised-section">
  <h1>
    {{ 'MY_PROFILE' | translate }}
  </h1>

  @if (userInfo$ | async; as response) {
    <p>{{ 'EMAIL' | translate }}</p>
    {{ response.email }}
    <br />

    <p>{{ 'FIRST_NAME' | translate }}</p>
    {{ response.firstName }}
    <br />

    <p>{{ 'LAST_NAME' | translate }}</p>
    {{ response.lastName }}
    <br />

    <p>{{ 'ACCOUNT' | translate }}</p>
    {{ response.account }}
  }
</section>
